import { render, staticRenderFns } from "./quizDialog.vue?vue&type=template&id=01513b60&scoped=true&"
import script from "./quizDialog.vue?vue&type=script&lang=js&"
export * from "./quizDialog.vue?vue&type=script&lang=js&"
import style0 from "./quizDialog.vue?vue&type=style&index=0&id=01513b60&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01513b60",
  null
  
)

export default component.exports